// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  cardId: __t.uuid().name("card_id"),
  displayName: __t.string().name("display_name"),
  interestDollarAmount: __t.i64().name("interest_dollar_amount"),
  supportiveMessage: __t.option(__t.string()).name("supportive_message"),
});
